import * as Yup from "yup";
import { reverseShape } from "Components/shared/helpers/reverse-shape";
import { date, validString, validBoolean } from "Components/shared/helpers/validations";


const pickupIDs = Yup.array().min(1)

export const AssignDriverSchema = Yup.object().shape(
  reverseShape({
    pickupIDs: pickupIDs.required(),
    vehicleID: validString.required(),
    assignedDriver: validString.required(),
  })
  );
  